export default {
  SHOW_DIALOG: '@YOLA_EDITOR/DIALOG/SHOW_DIALOG',
  HIDE_DIALOG: '@YOLA_EDITOR/DIALOG/HIDE_DIALOG',
};
